module.exports = __webpack_public_path__ + "img/con4_inp_m.5d720042.jpg";